import { z } from 'zod';
// ---- Entities (server -> client shapes) ----
export const RoleSchema = z.object({
    id: z.uuid(),
    code: z.string().min(1),
    nameTh: z.string().min(1),
    description: z.string().nullable().optional(),
    isSystem: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const RoleWithPermissionsSchema = RoleSchema.extend({
    permissions: z.array(z.string()),
});
export const UserRoleSchema = z.object({
    id: z.uuid(),
    userId: z.uuid(),
    companyId: z.uuid().nullable(), // null = global
    roleId: z.uuid(),
    createdBy: z.string().nullable().optional(),
    createdAt: z.coerce.date(),
});
export const UserWithRolesSchema = z.object({
    id: z.uuid(),
    email: z.email(),
    displayName: z.string(),
    roleCodes: z.array(z.string()),
    globalRoleCodes: z.array(z.string()),
});
// ---- Write DTOs ----
export const CreateRoleSchema = z.object({
    code: z
        .string()
        .min(1)
        .max(40)
        .regex(/^[A-Z0-9_]+$/, 'code must be UPPER_SNAKE'),
    nameTh: z.string().min(1),
    description: z.string().optional(),
});
export const UpdateRoleSchema = z.object({
    nameTh: z.string().min(1).optional(),
    description: z.string().nullable().optional(),
});
export const SetRolePermissionsSchema = z.object({
    // Keys are validated against PERMISSION_KEYS at API boot; kept as string here
    // so this schema stays decoupled from the live catalog.
    permissionKeys: z.array(z.string().min(1)),
});
export const AssignUserRolesSchema = z.object({
    roleIds: z.array(z.uuid()),
});
export const EffectivePermissionsSchema = z.object({
    companyId: z.uuid().nullable(),
    roles: z.array(z.string()),
    permissions: z.array(z.string()),
});
//# sourceMappingURL=rbac.js.map